import axios from 'axios';

/*
 * Axios calls required by the Web Form Submitted goal.
 *
 * These operations are against `WebformFunnelController` and `WebformManageController` in the infusionsoft module.
 */

const BASE_URL_FUNNEL = '/app/webFormFunnel';
const BASE_URL_MANAGE = '/app/webformManage';


export const createWebForm = async (title, funnelId) => {
    const { data } = await axios.post(`${BASE_URL_FUNNEL}/create?funnelId=${funnelId}`, title, {
        headers: {
            'Content-Type': 'text/html',
        },
    });

    return data;
};

export const getWebFormSettings = async (webFormId) => {
    const { data } = await axios.get(`${BASE_URL_MANAGE}/getWebFormSettings/${webFormId}`);

    return data;
};

export const saveCustomLink = async (webFormId, webFormName, customLink) => {
    const params = new FormData();

    params.append('webformId', Number(webFormId));
    params.append('webformName', webFormName);
    params.append('currentCustomLink', customLink);

    const { data } = await axios.post(`${BASE_URL_MANAGE}/saveCustomLink`, params, {
        headers: {
            'Content-Type': 'multipart/form-data',
        },
    });

    return data;
};

export const saveWebFormSettings = async (webFormId, funnelId, settings) => {
    if (settings) {
        await axios.put(`${BASE_URL_FUNNEL}/${webFormId}/${funnelId}`, settings);
    }
};

export const syncWebFormLabel = async (cell) => {
    const webFormId = cell.value?.webformId ?? 0;
    const newName = cell.value?.name ?? '';

    if (webFormId && newName) {
        await axios.put(`${BASE_URL_FUNNEL}/${webFormId}/name`, newName, {
            headers: {
                'Content-Type': 'text/html',
            },
        });
    }
};
